import axios from "axios";
import { API_CONFIGS, AXIOS_CONFIG } from "../configs";
import { toastr } from 'react-redux-toastr';

const axiosInstance = axios.create(AXIOS_CONFIG());

axiosInstance.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    if (error.response.status === 400) {
        const {
            response: {
            data: { message },
            },
        } = error;
        toastr.error(message);
    }

    return Promise.reject(error);
  }
);

export function encryptFile(id) {
  return axiosInstance.post(`${API_CONFIGS.ENCRYPT_FILE}/${id}`);
}

export function decryptFile(id) {
  return axiosInstance.post(`${API_CONFIGS.DECRYPT_FILE}/${id}`);
}
